// src/belediye/components/tasks/GorevDikkatSeridi.js
// FAZ-58 — DİKKAT ŞERİDİ (sayfanın sağındaki %30).
//
// Sol taraf "şu kümedeki tüm işler" sorusunu, bu şerit "başka nerede acil bir
// şey var" sorusunu cevaplar. ÜÇ kart hep aynı sırada durur:
//   gecikenler → onay bekleyenler → yakındakiler
// Hangi sekmedeysen o kart şeritten düşer (solda zaten tam listesi var) ve
// yerine "yeni gelenler" gelir — aynı iş ekranda iki kez görünmesin diye.
//
// Kartlar sayı KUTUSU değil, üzerinde iş yapılabilir KISA LİSTE. "Tümünü gör"
// pencere AÇMAZ: sol taraftaki sekmeye geçirir (kullanıcı kararı) — böylece
// arama, filtre ve sayfalama zaten hazır olan liste yapısıyla çalışılır.
//
// Yerleşim:
//   ≥1180px  sağda sütun; BAŞLIK BARININ ALTINA yapışır, sayfayla kaymaz
//   780-1179 listenin ÜSTÜNDE yan yana kartlar (tablet), kart başına 3 madde
//   <780px   listenin üstünde tek sütun, kart başına 2 madde (mobil)

import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { fetchTasks } from "../../services/internalTasksApi";
import { BaslangicDurumu, Taraflar, terminMetni } from "./GorevSatiri";
import "./gorev.css";

// Kullanıcı kararı: kart başına 5 madde (masaüstü). Tablet/mobilde CSS kırpar.
const KART_LIMIT = 5;

function DikkatKarti({ kart, onTumu, tarafGoster }) {
  const navigate = useNavigate();
  const [durum, setDurum] = useState({ yukleniyor: true, satirlar: [], toplam: 0 });

  const yukle = useCallback(() => {
    let canli = true;
    setDurum((d) => ({ ...d, yukleniyor: true }));
    fetchTasks({ ...kart.params, page: 1, page_size: KART_LIMIT })
      .then((r) => {
        if (!canli) return;
        setDurum({
          yukleniyor: false,
          satirlar: r?.results || [],
          toplam: r?.count || 0,
        });
      })
      .catch(() => canli && setDurum({ yukleniyor: false, satirlar: [], toplam: 0 }));
    return () => {
      canli = false;
    };
  }, [kart.params]);

  useEffect(() => yukle(), [yukle]);

  const { yukleniyor, satirlar, toplam } = durum;

  // Şerit ÜÇ SLOTLU ve sabittir: boş kart da çizilir. (Kart gizlenince
  // diğerleri yer değiştiriyor, kullanıcı "hep aynı yerde dursun" dedi.)
  return (
    <section className={`gk-dkart gk-dkart--${kart.tone}`} aria-labelledby={`dk-${kart.key}`}>
      <h3 className="gk-dkart-bas" id={`dk-${kart.key}`}>
        <span>{kart.baslik}</span>
        {toplam > 0 && <span className="gk-dkart-rozet">{toplam}</span>}
      </h3>

      {yukleniyor && <p className="gk-dkart-bos">Yükleniyor…</p>}

      {/* Boş mesajı NÖTR tonda: "geciken iş yok" yeşile boyanınca ekranda
          gereksiz bir renk daha oluyordu (kullanıcı kararı). */}
      {!yukleniyor && toplam === 0 && (
        <p className="gk-dkart-bos">{kart.bosMetin}</p>
      )}

      {!yukleniyor && satirlar.length > 0 && (
        // Safari, list-style:none uygulanan <ul>'de liste semantiğini DÜŞÜRÜR;
        // role="list" bilinen ve gerekli düzeltmedir (kural bunu bilmiyor).
        // eslint-disable-next-line jsx-a11y/no-redundant-roles
        <ul className="gk-dkart-liste" role="list">
          {satirlar.map((t) => (
            <li key={t.id}>
              {/* FAZ-59: kart satırı İKİ SATIR. Tek satırlık "ad + süre" hâli
                  "çok sığ" bulundu; alt satır kimin üzerinde olduğunu ve işe
                  başlanıp başlanmadığını söyler (yeni renk EKLEMEDEN). */}
              <button
                type="button"
                className="gk-dkart-satir"
                onClick={() => navigate(`/yonetim/gorevler/${t.id}`)}
              >
                <span className="gk-dkart-ust">
                  <span className="gk-dkart-ad">{t.title}</span>
                  <span className="gk-dkart-not">{terminMetni(t)}</span>
                </span>
                <span className="gk-dkart-alt">
                  <BaslangicDurumu task={t} />
                  <Taraflar task={t} tarafGoster={tarafGoster} />
                  {t.application && (
                    <span className="gk-satir-etiket" title="Bir vatandaş başvurusundan doğdu">
                      Başvuru
                    </span>
                  )}
                </span>
              </button>
            </li>
          ))}
        </ul>
      )}

      {!yukleniyor && toplam > 0 && (
        <button type="button" className="gk-dkart-tumu" onClick={() => onTumu(kart)}>
          Tümünü gör ({toplam})
        </button>
      )}
    </section>
  );
}

export default function GorevDikkatSeridi({ kartlar, onTumu, tarafGoster }) {
  const gecerli = (kartlar || []).filter(Boolean);
  if (!gecerli.length) return null;
  return (
    <aside className="gk-serit" aria-label="Dikkat gerektirenler">
      {gecerli.map((k) => (
        <DikkatKarti key={k.key} kart={k} onTumu={onTumu} tarafGoster={tarafGoster} />
      ))}
    </aside>
  );
}
